import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import '../bookingForm/bookingForm.css';

const EMAILJS_CONFIG = {
    serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID!,
    bookingTemplateId: process.env.REACT_APP_EMAILJS_BOOKING_TEMPLATE_ID!,
    autoReplyTemplateId: process.env.REACT_APP_EMAILJS_AUTO_REPLY_TEMPLATE_ID!,
    publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY!
};

const ContactForm: React.FC = () => {
    const formRef = useRef<HTMLFormElement>(null);
    const [successMessage, setSuccessMessage] = useState<string>('');
    const [errorMessage, setErrorMessage] = useState<string>('');

    const sendEmail = async (e: React.FormEvent<HTMLFormElement>) => {

        e.preventDefault();
        if (!formRef.current) return;
        try {
            const response = await emailjs.sendForm(
                EMAILJS_CONFIG.serviceId,
                EMAILJS_CONFIG.bookingTemplateId,
                formRef.current,
                EMAILJS_CONFIG.publicKey
            );
            console.log("Email sent!", response.status, response.text);
            setSuccessMessage('Tack! Ditt meddelande har skickats.');
            setErrorMessage('');
            formRef.current.reset();
            setTimeout(() => setSuccessMessage(''), 5000);
        } catch (error) {
            console.error("Failed to send email", error);
            setErrorMessage('Ett fel uppstod. Försök igen senare.');
            setSuccessMessage('');
        }
    };

    return (
        <form ref={formRef} onSubmit={sendEmail} className="bookingForm">
            <div className="bookingForm__topSection">
                <section>
                    <h3 className="h3-form">Namn</h3>
                    <input
                        type="text"
                        name="name"
                        placeholder="Namn"
                        required
                        className="bookingForm__input"
                    />
                </section>
                <section>
                    <h3 className="h3-form">E-post</h3>
                    <input
                        type="email"
                        name="user_email"
                        placeholder="E-post"
                        required
                        className="bookingForm__input"
                    />
                </section>
            </div>

            <div className="bookingForm__bottomSection">
                <section>
                    <h3 className="h3-form">Meddelande</h3>
                    <textarea
                        name="message"
                        placeholder="Meddelande"
                        required
                        className="bookingForm__textarea"
                    />
                </section>

                <button type="submit" className="bookingForm__button">
                    Skicka
                </button>
            </div>

            {successMessage && <p className="bookingForm__success">{successMessage}</p>}
            {errorMessage && <p className="bookingForm__error">{errorMessage}</p>}
        </form>
    );
};

export default ContactForm;

